// export const LogoWeb = require('./ewako88.png');
// export const LogoWeb = require('./ik88.png');
// export const LogoWeb = require('./ratuzeus.png');
// export const LogoWeb = require('./hujanbet.png');
// export const LogoWeb = require('./jamtoto.png');
export const LogoWeb = require('./hino99.png');